import React, { Component } from "react";
import '../header.css'
import '../features.css';

export class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isVideoLoaded: false
    }
    this.videoLoad = this.videoLoad.bind(this);
  }
  componentDidMount() {
    const video = document.getElementById('myVideo');
    if (video) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }
    }
  }

  videoLoad(e) {
    this.setState({ isVideoLoaded: true })
  }

  render() {
    const { isVideoLoaded } = this.state;
    return (
      <header id="header" className="header-container">
        <video
          className={`hero-video ${isVideoLoaded ? 'post-header-enhanced' : 'hidden'}`}
          onLoadedData={() => this.videoLoad()}
          autoPlay
          playsInline
          muted
          loop
          id="myVideo"
        >
          <source src="videos/logv3.mp4" type="video/mp4" />
          Any alternate text.
        </video>
        <div className={`post-header ${isVideoLoaded ? 'hidden' : ""}`}></div>
        <div className="bg-overlay"></div>

        <div className="hero-content">
          <h1 className="hero-title">Lesson On Golf</h1>
          <p className="hero-sub">Half-Off Golf. Featured Courses. Pro Pointers.</p>

          <a
            href="https://www.iwgcc.com"
            target="_blank"
            rel="noopener noreferrer"
            className="featured-card"
          >
            <div className="featured-card-inner">
              <div className="featured-logo-wrap">
                <img
                  src="img/indianwood.jpg"
                  className="featured-logo"
                  alt="Indianwood Country Club"
                />
              </div>
              <div className="featured-body">
                <span className="featured-eyebrow">Our Featured Course</span>
                <h3 className="featured-title">Indianwood C.C.</h3>
                <p className="featured-desc">Est. 1925 &middot; Lake Orion, MI</p>
                <div className="featured-btn-row">
                  <span className="btn btn-custom btn-lg featured-btn primary-btn">
                    Check It Out
                  </span>
                </div>
              </div>
            </div>
          </a>

          <a
            href="https://lessongolf.myshopify.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-custom btn-lg hero-deals-btn"
          >
            View All Deals
          </a>
        </div>
      </header>
    );
  }
}

export default Header;
